function dataValidate(c, { validationHelpers: f = {}, rules: d, dataRule: o, dataErrorMessages: y = {} }) {
  let p = {};
  function g(e, i) {
    if (!e || typeof i != 'string') return;
    let n = i.split('.'),
      t = e;
    for (let a of n) {
      if (t[a] === void 0) return;
      t = t[a];
    }
    return t;
  }
  async function s(e, i = null) {
    let { rule: n, required: t } = o[e.key];
    if (((n && t) || (!t && e.value != '')) && n) {
      let a = n.split('--')[0],
        r = n.split('--').length > 1 ? n.split('--')[1] : '',
        h = k(e.value, d[a], r, f, i),
        { isValid: u, errorMessage: m, errorType: v } = await h.validate();
      return u || (p[e.key] = { name: e.key, error: !0, errorMessage: g(y, m) || m, errorType: v }), u;
    }
    return !0;
  }
  async function l() {
    let e = Object.keys(c).map((i) => ({ key: i, value: c[i] }));
    if (e && e.length > 0) {
      if (!Object.keys(o).every((r) => c.hasOwnProperty(r))) return { error: !0, errorMessage: 'Missing properties' };
      if ((await Promise.all([...e].map(async (r) => await s(r, c)))).some((r) => !r))
        return { error: !0, dataErrors: p };
      let n = Object.keys(o).map((r) => ({ key: r, required: o[r].required })),
        t = e.map((r) => r.key);
      if (
        !n
          .filter((r) => r.required)
          .map((r) => r.key)
          .every((r) => t.includes(r))
      )
        return { error: !0 };
    } else if (!e || e.length === 0) return { error: !0, errorMessage: 'Missing fields for dataRules' };
    return { ok: !0 };
  }
  return l();
}
function k(c, f, d = null, o = null, y = null) {
  async function p(s) {
    let l, e;
    return {
      isValid: !(
        await Promise.all(
          s.validate.map(async (t) => {
            let a = !0;
            if (s.params && s.params[t] && s.params[t].length > 0) {
              let r = s.params[t].map((u) => (typeof u == 'string' && u[0] === '$' ? u.substring(1, u.length) : u));
              a = await this[t](...r);
            } else a = await this[t]();
            return !a && !l && s?.error[t] && ((l = s.error[t]), (e = t)), a;
          })
        )
      ).some((t) => !t),
      errorMessage: l,
      errorType: e,
    };
  }
  async function g() {
    if (o && typeof o == 'function') {
      let l = o(c, f, d, y);
      Object.keys(l).forEach((e) => {
        this[e] = l[e];
      });
    }
    return d ? await p.call(this, f.modifier[d]) : await p.call(this, f);
  }
  return { validate: g };
}

function FormManager(formElement, dataRule, rules, validationHelpers, dataErrorMessages) {
  const state = {
    onceError: false,
  };

  async function handleInputChange(e) {
    if (!state.onceError) return;
    const formData = getFormData(formElement);
    const formRule = mockInputDataRules(formData);
    let fieldRule = dataRule[e.target.name] ? dataRule[e.target.name] : null;
    if (!fieldRule) {
      fieldRule = {
        rule: e.target.dataset.rule,
        required: true,
      };
    }
    const inputValidated = await dataValidate(
      { ...formData, [e.target.name]: e.target.value },
      { validationHelpers, rules, dataRule: { ...formRule, [e.target.name]: fieldRule }, dataErrorMessages }
    );
    toogleErrorMessage(e.target, inputValidated?.dataErrors?.[e.target.name]);
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    return new Promise(async (resolve, reject) => {
      const formData = getFormData(formElement);
      const formDataKeys = Object.keys(formData);
      const fieldNameDuplicateds = [];
      const dataRuleWithDuplicates = JSON.parse(JSON.stringify(dataRule));

      Object.keys(dataRule).forEach((key) => {
        if (formDataKeys.indexOf(`${key}2`) > -1) {
          fieldNameDuplicateds.push(key);
        }
      });

      fieldNameDuplicateds.forEach((fieldNameDuplicated) => {
        let hasDuplicated = true;
        let indexDuplicated = 2;
        while (hasDuplicated && indexDuplicated < 6) {
          if (formDataKeys.indexOf(`${fieldNameDuplicated}${indexDuplicated}`) > -1) {
            dataRuleWithDuplicates[`${fieldNameDuplicated}${indexDuplicated}`] =
              dataRuleWithDuplicates[fieldNameDuplicated];
            indexDuplicated += 1;
          } else {
            hasDuplicated = false;
          }
        }
      });

      const formValidated = await dataValidate(formData, {
        validationHelpers,
        rules,
        dataRule: dataRuleWithDuplicates,
        dataErrorMessages,
      });
      const inputElements = formElement.querySelectorAll('input, textarea, select');

      const currentStep = parseInt(formElement.dataset.step);
      const lastStep = parseInt(formElement.dataset.lastStep);

      if (currentStep < lastStep) {
        if (formElement.dataset.formSteps && currentStep && formValidated?.dataErrors) {
          Object.keys(formValidated.dataErrors).forEach((key) => {
            inputElements.forEach((inputElement) => {
              if (inputElement.name === key) {
                const fieldElement = inputElement.closest('.crmf-field');
                if (fieldElement.dataset.step != currentStep) {
                  delete formValidated.dataErrors[key];
                }
              }
            });
          });
        }

        if (formValidated.error && formValidated.dataErrors && Object.keys(formValidated.dataErrors).length === 0) {
          delete formValidated.error;
          delete formValidated.dataErrors;
          formValidated.ok = true;
        }
      }

      if (formValidated.error) {
        state.onceError = true;
        inputElements.forEach((inputElement) => {
          toogleErrorMessage(inputElement, formValidated?.dataErrors?.[inputElement.name]);
        });
        resolve({ ...formValidated, formData });
      } else if (formValidated.ok) {
        resolve({ ...formValidated, formData });
      }
      reject({ error: true });
    });
  }

  function handleFormReset() {
    formElement.querySelectorAll('input').forEach((inputElement) => {
      const fieldElement = inputElement.parentElement;
      const errorElement = fieldElement.querySelector('.check-rule-mate-error');

      inputElement.value = '';
      fieldElement.classList.remove('field-error');
      if (errorElement) {
        fieldElement.removeChild(errorElement);
      }
    });
    state.onceError = false;
  }

  function getFormData(formElement, isDisplayFormat = false) {
    const elements = formElement.querySelectorAll('input, textarea, select');
    const formData = {};

    elements.forEach((element) => {
      const { name, type, value, checked } = element;
      if (name) {
        if (type === 'checkbox' || type === 'radio') {
          if (checked) {
            if (type === 'checkbox' && isDisplayFormat) {
              const labelElement = element.parentElement.querySelector('label');
              if (formData[name] && labelElement?.innerText) {
                formData[name] += ', ' + labelElement.innerText;
              }
              if (!formData[name]) {
                formData[name] = labelElement?.innerText ? labelElement.innerText : '';
              }
            } else {
              if (formData[name] && value) {
                formData[name] += ', ' + value;
              }
            }
          }
          if (!formData[name]) {
            formData[name] = value ? value : '';
          }
        } else {
          formData[name] = value;
        }
      }
    });
    return formData;
  }

  function mockInputDataRules(formData) {
    const formRule = {};
    Object.keys(formData).forEach((key) => {
      formRule[key] = {
        rule: 'hasText',
        required: false,
      };
    });
    return formRule;
  }

  function addAttributes() {
    Object.keys(dataRule).forEach((key) => {
      if (rules[dataRule[key].rule]?.attributes) {
        Object.keys(rules[dataRule[key].rule]?.attributes).forEach((attributeKey) => {
          if (rules[dataRule[key].rule]?.attributes?.[attributeKey]) {
            const inputElement = formElement.querySelector(`input[name="${key}"], textarea[name="${key}"]`);
            if (inputElement && inputElement[attributeKey]) {
              inputElement[attributeKey] = rules[dataRule[key].rule]?.attributes[attributeKey];
            } else if (inputElement && attributeKey.indexOf('data-') > -1) {
              const datasetArr = attributeKey.split('data-');
              inputElement.dataset[datasetArr[1]] = rules[dataRule[key].rule]?.attributes[attributeKey];
            }
          }
        });
      }
      if (dataRule[key].attributes) {
        Object.keys(dataRule[key].attributes).forEach((attributeKey) => {
          if (attributeKey === 'label') {
            const labelElement = formElement.querySelector(`label[for=${key}]`);
            if (labelElement) {
              labelElement.textContent = dataRule[key].attributes[attributeKey];
            }
          } else {
            const inputElement = formElement.querySelector(`input[name="${key}"], textarea[name="${key}"]`);
            if (inputElement && inputElement[attributeKey]) {
              inputElement[attributeKey] = dataRule[key].attributes[attributeKey];
            } else if (inputElement && attributeKey.indexOf('data-') > -1) {
              const datasetArr = attributeKey.split('data-');
              inputElement.dataset[datasetArr[1]] = dataRule[key]?.attributes[attributeKey];
            }
          }
        });
      }
    });
  }

  function toogleErrorMessage(inputElement, dataError) {
    if (inputElement.type === 'checkbox') {
      return;
    }
    const fieldElement = inputElement.parentElement;
    const fieldErrorElement = fieldElement.querySelector('.check-rule-mate-error');
    fieldElement.classList.add('field-error');
    if (dataError) {
      if (fieldErrorElement) {
        fieldErrorElement.textContent = dataError.errorMessage;
      } else {
        const newFieldErrorElement = window.document.createElement('span');
        newFieldErrorElement.classList.add('check-rule-mate-error');
        newFieldErrorElement.innerHTML = dataError.errorMessage;
        fieldElement.appendChild(newFieldErrorElement);
      }
    } else {
      fieldElement.classList.remove('field-error');
      if (fieldErrorElement) {
        fieldElement.removeChild(fieldErrorElement);
      }
    }
  }

  return {
    handleFormSubmit,
    handleFormReset,
    handleInputChange,
    addAttributes,
    getFormData,
  };
}
